import { DataManager } from '@syncfusion/ej2-data';
import { getMerchantsODataUrl } from '../../config/api';
import { buildAuthorizationHeaders } from '../http/authHeaders';
import { AuthorizedODataV4Adaptor } from './authorizedODataV4Adaptor';

export function createMerchantsDataManager(
  getAccessToken: () => string | undefined
): DataManager | null {
  const url = getMerchantsODataUrl();
  if (!url) {
    return null;
  }

  return new DataManager({
    url,
    adaptor: new AuthorizedODataV4Adaptor(getAccessToken),
    headers: buildAuthorizationHeaders(getAccessToken),
  });
}
